import React from 'react'
import { Link } from 'react-router-dom'

class NaviBar extends React.Component {
  render(){
    return(
      <div>
        <Link to="/">Home</Link>
        <br/>
        <Link to="/Ruchen">Ruchen</Link>
        <br/>
        <Link to="/LAZY">LAZY</Link>
        <br/>
        <Link to="/EveAlarm">EveAlarm</Link>
      </div>
    )
  }
}

export default NaviBar;